import FingerprintJS from '@fingerprintjs/fingerprintjs';

function initRememberMe(){

}

/**
 * Handles form submission
 */
function addSubmitClickHandler() {
    const form = document.getElementById('topic-add');
    const submitButton = document.getElementById('button-submit');
    const previewButton = document.getElementById('button-preview');

    /**
     * Handles the Recaptcha
     *
     * @param callback - function to call when all is finished
     */
    function handleRecaptcha(callback) {
        const SITE_KEY = document.querySelector('[data-recaptcha-key]').dataset.recaptchaKey;
        const USER_ACTION = 'TOPIC_ADD';

        grecaptcha.enterprise.ready(async () => {
            const token = await grecaptcha.enterprise.execute(SITE_KEY, {action: USER_ACTION});
            const inputToken = document.createElement('input');
            const inputAction = document.createElement('input');

            inputToken.setAttribute('name', 'token');
            inputToken.setAttribute('type', 'hidden');
            inputToken.setAttribute('value', token);
            inputAction.setAttribute('name', 'user_action');
            inputAction.setAttribute('type', 'hidden');
            inputAction.setAttribute('value', USER_ACTION);

            form.appendChild(inputToken);
            form.appendChild(inputAction);
            callback();
        });
    }

    function validateInputs() {
        if(!document.getElementById('topic').value) {
            return false;
        }

        if(!document.getElementById('name').value) {
            return false;
        }

        // TODO validate email value?
        if(!document.getElementById('email').value) {
            return false;
        }

        if(!document.getElementById('textarea-message').value) {
            return false;
        }

        return true;
    }

    async function handleChitChat() {
        const chitChatPromise = FingerprintJS.load()
        const chitchatAgent = await chitChatPromise;
        const result = await chitchatAgent.get();
        const input = document.createElement('input');
        input.setAttribute('name', 'chitchat');
        input.setAttribute('type', 'hidden');
        input.setAttribute('value', result.visitorId);
        form.appendChild(input);
        handleSubmit();
    }

    function handleSubmit() {
        const input = document.createElement('input');
        input.setAttribute('name', 'button_submit');
        input.setAttribute('type', 'hidden');
        input.setAttribute('value', 'submit');
        form.appendChild(input);
        form.submit();
    }

    submitButton.addEventListener('click', function(event) {
        event.preventDefault();
        submitButton.classList.add('loading');
        submitButton.disabled = true;
        previewButton.disabled = true;

        if(validateInputs()) {
            handleRecaptcha(handleChitChat);
        } else {
            alert('Required fields can not be empty');
            submitButton.classList.remove('loading');
            submitButton.disabled = false;
            previewButton.disabled = false;
        }
        return false;
    });
}

/**
 * Adds emoji to the post textarea
 */
function addEmojiClickHandler() {
    const textarea = document.getElementById('textarea-message');
    const container = document.getElementById('emoji-container');
    container.addEventListener('click', function(event) {
        if(event.target.nodeName === 'IMG') {
            textarea.setRangeText(
                ' ' + event.target.dataset.code + ' ',
                textarea.selectionStart,
                textarea.selectionEnd,
                'end'
            )
        }
    });
}

/**
 * Class that handles adding a topic / post
 */
export class TopicAdd {
    init() {
        // console.log('>>> init topic ad!');
        addSubmitClickHandler();
        addEmojiClickHandler();
        // initRememberMe();
    }
}
